@if (form && definition) {
  <div
    class="flex flex-col"
    >
    <label class="soft-label soft-label-top"
      >{{ definition.title }}
      @if (definition.required | booleanRule: form.value) {
        <span
          class="required-indicator"
          >*</span
          >
        }
      </label>
      @switch (definition.control) {
        @case ('datetime') {
          <soft-date-time-input
            [formControl]="form|formControl:definition.name"
            softFieldValidation
          ></soft-date-time-input>
        }
        @case ('time') {
          <soft-time-input
            [formControl]="form|formControl:definition.name"
            [format]="definition.format | formatRule: form.value"
            softFieldValidation
          ></soft-time-input>
        }
        @default {
          <soft-date-input
            [formControl]="form|formControl:definition.name"
            [format]="definition.format | formatRule: form.value"
            softFieldValidation
          ></soft-date-input>
        }
      }
    </div>
  }
